export enum WizardGroupEnum {
  MyInfo = 1,
  MyFinances = 2,
  PropertyAndLoan = 3,
  Declarations = 4,
  ReviewAndSubmit = 5
}
